
export function showPercent( x: number, decimalPlaces: number = 1 ) {
    return `${(x * 100).toFixed( decimalPlaces )}%`;
}